
// src/web/components/members-page.jsx

import React from 'react'
import connect from '../../connects/members-page'
import {
  List,
  ListItem,
} from 'react-toolbox/lib/list'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import RightSidePage from './right-side-page.jsx'
import DiaryContent from './diary-content.jsx'
import membersPageNoDescriptionTheme from './themes/members-page-no-description.css'
import membersPageWithDescriptionTheme from './themes/members-page-with-description.css'
import favoriteButtonTheme from './themes/favorite-button.css'
import Loading from './loading.jsx'

class MemberItem extends React.Component {
  render() {
    const {
      t,
      user,
      member,
      isFavorite,
      toggleFavoriteUser,
      openUserProfilePanel,
    } = this.props

    return (
      <ListItem selectable={false} ripple={false}
          theme={!member.description && membersPageNoDescriptionTheme || membersPageWithDescriptionTheme}
          avatar={member.icon_image.thumb_url}
          rightActions={member.user_id == user.user_id &&
            [<Button key={1} raised onClick={openUserProfilePanel} icon="edit" label={t('label:編集')}/>] ||
            [<Button key={2} className={isFavorite ? 'favorite' : ''} icon={isFavorite ? "flag" : "outlined_flag"} theme={favoriteButtonTheme}
              label={isFavorite ? t("label:フォロー中") : t("label:フォロー")}
              onClick={()=> toggleFavoriteUser(member, isFavorite)}/>]
          }
          caption={member.name}
          legend={member.description && <DiaryContent component='div' comment content={member.description} />} />
    )
  }
}

class MembersPage extends React.Component {
  render() {
    const {
      t,
      group,
      user,
      openUserProfilePanel,
      openGroupProfilePanel,
      isFavorite,
      isFetching,
      isFetchGroupFailed,
      toggleFavoriteUser,
    } = this.props

    return (
      <RightSidePage title={t("label:メンバーリスト")} icon='people' >
        {!isFetchGroupFailed && isFetching && <Loading />}
        {!isFetchGroupFailed &&
          <List>
            {group && (group.description || group.is_admin) &&
              <ListItem selectable={false} ripple={false}
                  rightActions={group.is_admin &&
                    [<Button key={1} raised onClick={openGroupProfilePanel} icon="edit" label={t('label:編集')} />] || []
                  }
                  theme={membersPageNoDescriptionTheme}
                  legend={<DiaryContent component='div' comment content={group.description || t('label:ミッションが設定されていません')} />} /> || null
            }
            {group && group.members && group.members.length > 0 && _.map(group.members, (member)=>
              <MemberItem key={member.user_id} t={t} user={user}
                member={member} isFavorite={isFavorite(member, this.props)}
                toggleFavoriteUser={toggleFavoriteUser}
                openUserProfilePanel={openUserProfilePanel} />
            )}
          </List>
        }
        {!isFetchGroupFailed && !isFetching && group && (!group.members || group.members.length == 0) &&
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {t('label:メンバーは登録されていません')}
          </div>
        }
        {isFetchGroupFailed &&
          <div style={{ marginTop: '10px', textAlign: 'center'}}>{t('label:メンバーの取得に失敗しました')}</div>
        }
      </RightSidePage>
    )
  }
}

export const RawMembersPage = MembersPage
export default connect(MembersPage)



// WEBPACK FOOTER //
// ./src/web/components/members-page.jsx